// src/context/TokenContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const istekId = () => (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : null);

const TokenContext = createContext();

export function TokenProvider({ children }) {
  const [tokenBalance, setTokenBalance] = useState(0);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Oturum dinle
  useEffect(() => {
    // Mevcut oturumu kontrol et
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchBalance(session.user.id);
      else setLoading(false);
    });

    // Oturum değişimlerini dinle
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchBalance(session.user.id);
      else {
        setTokenBalance(0);
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  // Token bakiyesini Supabase'den çek
  async function fetchBalance(userId) {
    setLoading(true);
    const { data, error } = await supabase
      .from('profiles')
      .select('token_balance')
      .eq('id', userId)
      .single();

    if (!error && data) {
      setTokenBalance(data.token_balance);
    }
    setLoading(false);
  }

  // Token harca
  async function harcaToken(miktar, sebep = 'fal') {
    if (!user) return false;
    await supabase.auth.getSession();
    const { data, error } = sebep === 'remil_iade'
      ? await supabase.rpc('token_remil_iade')
      : await supabase.rpc('token_harca', { p_miktar: miktar, p_sebep: sebep, p_istek_id: istekId() });
    if (error) { console.error('Token hatasi:', error.message); return false; }
    setTokenBalance(data);
    return true;
  }

  // Token ekle (reklam, satın alma vb.)
  async function ekleToken(miktar, sebep = 'reklam') {
    if (!user) return false;
    await supabase.auth.getSession();
    const { data, error } = await supabase.rpc('token_reklam_odulu', { p_istek_id: istekId() });
    if (error) { console.error('Token hatasi:', error.message); return false; }
    setTokenBalance(data);
    return true;
  }

  async function gunlukBonus() {
    if (!user) return null;
    try {
      const session = await supabase.auth.getSession();
      const token = session.data.session?.access_token;
      if (!token) return null;
      const { data, error } = await supabase.functions.invoke("gunluk-bonus", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (error || !data?.success) return null;
      setTokenBalance(data.token_balance);
      return data;
    } catch {
      return null;
    }
  }

  return (
    <TokenContext.Provider value={{
      tokenBalance,
      user,
      loading,
      harcaToken,
      ekleToken,
      fetchBalance,
      gunlukBonus,
    }}>
      {children}
    </TokenContext.Provider>
  );
}

export function useToken() {
  return useContext(TokenContext);
}
